import Alert from "@mui/material/Alert";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {useSearchResultDetailsState} from "../search-result-details/SearchResultDetailsContext";
import {useEffect, useState} from "react";

export const CopyrightClauseWarning = ({t}) => {

    const {model} = useSearchResultDetailsState();

    const [clause, setClause] = useState('');

    const stripTitle = title => {
        if (title.indexOf('(') > -1) {
            title = title.substring(0, title.indexOf('('));
        }
        return title;
    };

    const getFirstCopyrightClause = () => {
        const {copyrightInfo = []} = model.content;
        if (copyrightInfo.length === 0) {
            setClause('');
        } else {
            const title = stripTitle(copyrightInfo[0]?.title || '');
            setClause(title);
        }
    };

    useEffect(() => {
        if (!model || model?.content?.copyrightInfo?.length === 0) {
            return;
        }
        getFirstCopyrightClause();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [model]);

    return clause !== '' && <Alert icon={<WarningAmberIcon/>} severity="warning">
        <b>{t('obs', 'OBS')}:</b> {clause}
    </Alert>;
};